import { useState } from 'react';
import LogoScalar from '../../assets/img/logo-scalar.png';
import { Icon } from '@iconify/react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { to: '/inicio', label: 'Inicio' },
  { to: '/nosotros', label: 'Nosotros' },
  { to: '/portafolio', label: 'Portafolio' },
  { to: '/contacto', label: 'Contacto' },
];

function isActive(pathname: string, to: string): boolean {
  if (to === '/inicio') return pathname === '/' || pathname === '/inicio';
  return pathname === to;
}

export default function Menu(){
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg shadow-black/5">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center justify-between h-16">
              <Link className="flex-shrink-0" to="/">
                <img className="h-10 w-auto" src={LogoScalar} alt="logo" />
              </Link>
              <div className="flex items-center gap-2">
                <div className="hidden md:flex md:items-center md:gap-1">
                  {links.map(link => (
                    <Link key={link.to} className={`px-4 py-2 text-sm rounded-lg transition-colors ${isActive(pathname, link.to) ? 'text-[#f26724] bg-orange-50' : 'text-gray-600 hover:text-[#f26724] hover:bg-orange-50'}`} to={link.to}>{link.label}</Link>
                  ))}
                </div>
                <button onClick={() => setOpen(!open)} className="md:hidden p-2 text-gray-500 hover:text-[#f26724] transition-colors">
                  {open ? <Icon icon="mdi:close" className="text-2xl" /> : <Icon icon="mdi:menu" className="text-2xl" />}
                </button>
              </div>
            </div>
          </div>
          {open && (
            <div className="md:hidden bg-white border-t border-black/10 px-4 py-3 space-y-1">
              {links.map(link => (
                <Link key={link.to} onClick={() => setOpen(false)} className={`block px-4 py-2 text-sm rounded-lg transition-colors ${isActive(pathname, link.to) ? 'text-[#f26724] bg-orange-50' : 'text-gray-600 hover:text-[#f26724] hover:bg-orange-50'}`} to={link.to}>{link.label}</Link>
              ))}
            </div>
          )}
        </nav>
    )
}
